<ng-container *ngIf="videoData$ | async as videoData">
    <ng-container *ngIf="element.settings.general.coverText && !hasToPlaceIconRelative; then coverText"></ng-container>
    <ng-container *ngIf="element.settings.general.link?.type; else ownVideo">
        <render-link *ngIf="element.settings?.general?.link?.type" [link]="element.settings.general.link" [element]="element">
            <ng-container *ngTemplateOutlet="ownVideo"></ng-container>
        </render-link>
    </ng-container>

    <ng-template #ownVideo>
        <div cmsPlayOnView [cmsVideoUrl]="videoData.videoSrc" [videoElement]="videoElement" class="video" [class.show-only-poster]="showOnlyPoster">
            <video
                #videoElement
                class="own-video"
                [ngStyle]="{ 'aspect-ratio': videoData.skeleton.aspectRatio }"
                fixImageHeightSafari
                [aspectRatioSize]="videoData.skeletonObj"
                (click)="playVideoWithoutControls(videoElement)"
                [controls]="controls"
                [cmsAkamaiDynamicPosterVideo]="videoData.posterSrcSet"
                [cmsIdElement]="this.id"
                [cmsNativeElement]="videoElement"
                [cmsAkamaiWidthImage]="videoData.poster"
                [cmsAkamaiWidthImageAttribute]="'poster'"
                [loop]="loop"
                [muted]="muted"
                [autoplay]="autoPlay"
                playsinline
                (play)="showOnlyPoster = false"
            >
                <source [src]="videoData.videoSrc" />
            </video>
            <ng-container *ngTemplateOutlet="audioIconButton"></ng-container>
        </div>
    </ng-template>

    <ng-template #audioIconButton>
        <div
            *ngIf="element.settings.general.showMediaAudio"
            class="audio-icon"
            [ngClass]="{
                'audio-icon-top-left': audioIconPosition === 'top-left',
                'audio-icon-top-center': audioIconPosition === 'top-center',
                'audio-icon-top-right': audioIconPosition === 'top-right',
                'audio-icon-center-left': audioIconPosition === 'center-left',
                'audio-icon-center-center': audioIconPosition === 'center-center',
                'audio-icon-center-right': audioIconPosition === 'center-right',
                'audio-icon-bottom-left': audioIconPosition === 'bottom-left',
                'audio-icon-bottom-center': audioIconPosition === 'bottom-center',
                'audio-icon-bottom-right': audioIconPosition === 'bottom-right',
                'audio-icon-top-text': audioIconPosition === 'top-text',
                'audio-icon-bottom-text': audioIconPosition === 'bottom-text'
            }"
        >
            <div class="audio-tools">
                <div *ngIf="audioControls" (click)="mute($event)" class="piece-video-audio-icon">
                    <svg-icon *ngIf="!muted" src="audio-on" class="ico-white"></svg-icon>
                    <svg-icon *ngIf="muted" src="audio-off" class="ico-white"></svg-icon>
                </div>
                <ng-container *ngIf="hasToPlaceIconRelative">
                    <ng-container *ngTemplateOutlet="coverText"></ng-container>
                </ng-container>
            </div>
        </div>
    </ng-template>

    <ng-template #coverText>
        <div class="wysiwyg" *ngIf="!!element.settings && !!element.settings.general.coverText">
            <div class="wysiwyg-position">
                <render-wysiwyg
                    *ngIf="element.settings && element.settings.general.coverText"
                    [html]="element.settings.general.coverText"
                    [textPaddingTop]="element.settings.general.textPaddingTop"
                    [textPaddingBottom]="element.settings.general.textPaddingBottom"
                    [textPaddingLeft]="element.settings.general.textPaddingLeft"
                    [textPaddingRight]="element.settings.general.textPaddingRight"
                    data-e2e="render-cover-text"
                ></render-wysiwyg>
            </div>
        </div>
    </ng-template>
</ng-container>
